<template>
    <div>
        <component :is="currentStepComponent" />
    </div>
</template>

<script>
import Step1 from "./Step1.vue";
import Step2 from "./Step2.vue";
import Step3 from "./Step3.vue";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
    components: { Step1, Step2, Step3 },

    data() {
        return {
            componentKey: 0
        };
    },

    computed: {
        ...mapGetters(["step"]),

        currentStepComponent() {
            const steps = {
                1: Step1,
                2: Step2,
                3: Step3,
            };
            return steps[this.step];
        }
    },
    methods: {
        ...mapActions(['changeStep']),
    },

    // created() {
    //     window.addEventListener('popstate', () => {
    //         const urlParams = new URLSearchParams(window.location.search);
    //         const step = urlParams.get('step');
    //
    //         if (step) {
    //             this.changeStep(parseInt(step));
    //         }
    //     });
    // }

};
</script>
